import { GoogleOutlined } from '@ant-design/icons'
import { ProviderAuthenticationClient } from '~/plugins/data-connector/authentication/client'
import { ProviderHelperClient } from '~/plugins/data-connector/helpers/provider.helper.client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderGoogleDocCommon } from '../common'
import { FormConnectSteps } from './FormConnectSteps'
import { FormSetupSteps } from './FormSetupSteps'

export const ProviderGoogleDocClient: ProviderClient = {
  key: ProviderGoogleDocCommon.key,
  authentication: ProviderAuthenticationClient.Oauth2({
    ...ProviderGoogleDocCommon.authentication,
    clientId: ProviderHelperClient.getEnvVariable('google', 'CLIENT_ID'),
  }),
  description: {
    icon: <GoogleOutlined />,
    label: 'Google Doc',
    triggers: [],
    actions: [
      {
        key: 'getDocumentContentBlocks',
        label: 'Get document blocs',
        input: [{ key: 'documentId' }],
        output: [
          {
            key: 'blocs',
            type: 'array_objects',
            properties: [
              { key: 'endIndex', type: 'number' },
              { key: 'paragraph', type: 'any' },
              { key: 'sectionBreak', type: 'any' },
              { key: 'startIndex', type: 'number' },
              { key: 'table', type: 'any' },
              { key: 'tableOfContents', type: 'any' },
            ],
          },
        ],
      },
      {
        key: 'getDocumentContentText',
        label: 'Read document',
        input: [{ key: 'documentId' }],
        output: [{ key: 'content' }],
      },
      {
        key: 'listDocuments',
        label: 'Find many documents',
        input: [],
        output: [
          {
            key: 'documents',
            type: 'array_objects',
            properties: [{ key: 'name' }],
          },
        ],
      },
      {
        key: 'createDocument',
        label: 'Create a document',
        input: [{ key: 'title', type: 'string' }],
        output: [
          {
            key: 'document',
            type: 'object',
          },
        ],
      },
      {
        key: 'overwriteDocument',
        label: 'Update a document',
        input: [
          { key: 'documentId', type: 'string' },
          { key: 'content', type: 'string' },
        ],
        output: [{ key: 'document', type: 'object' }],
      },
      {
        key: 'copyDocument',
        label: 'Copy a document',
        input: [
          { key: 'documentId', type: 'string' },
          { key: 'title', type: 'string' },
        ],
        output: [{ key: 'document', type: 'object' }],
      },
      {
        key: 'fillDocumentContentPlaceholders',
        label: `Fill a document's placeholders`,
        input: [
          { key: 'documentId', type: 'string' },
          { key: 'items', type: 'object' },
        ],
        output: [{ key: 'document', type: 'object' }],
      },
      {
        key: 'getDocumentContentPlaceholder',
        label: `Get a document's placeholders`,
        input: [{ key: 'documentId', type: 'string' }],
        output: [{ key: 'placeholders', type: 'array' }],
      },
      {
        key: 'downloadDocumentAsDocx',
        label: `Download a document as a docx buffer`,
        input: [{ key: 'documentId', type: 'string' }],
        output: [{ key: 'buffer', type: 'object' }],
      },
    ],
  },
  FormSetupSteps,
  FormConnectSteps,
}
